import { useMutation, useQueryClient } from '@tanstack/react-query'
import { refreshMoneyQueries } from '@/features/bill/index.ts'
import { useTRPC } from '@/trpc/react.ts'

export function useOrderGroupMutation() {
  const trpc = useTRPC()
  const cache = useQueryClient()
  return useMutation(
    trpc.order.groups.manage.mutationOptions({
      onSuccess: async () => {
        await Promise.all([
          refreshMoneyQueries(cache, trpc),
          cache.invalidateQueries(trpc.order.groups.overview.queryFilter()),
          cache.invalidateQueries(trpc.order.groups.list.queryFilter()),
          cache.invalidateQueries(trpc.order.groups.options.queryFilter()),
          cache.invalidateQueries(trpc.order.subjects.list.queryFilter()),
          cache.invalidateQueries(trpc.order.subjects.options.queryFilter()),
          cache.invalidateQueries(trpc.contract.document.list.queryFilter()),
          cache.invalidateQueries(trpc.contract.document.detail.queryFilter()),
          cache.invalidateQueries(trpc.order.contracts.list.queryFilter()),
          cache.invalidateQueries(trpc.order.contracts.summary.queryFilter()),
          cache.invalidateQueries(trpc.order.contracts.documents.queryFilter()),
          cache.invalidateQueries(trpc.order.rental.currentContract.queryFilter())
        ])
      }
    })
  )
}
